import React, { Component } from 'react';
import Header from '../components/Header'
import ChatRow from '../components/ChatRow'
import NewChatBtn from '../components/NewChatBtn';
import CancelNewChatBtn from '../components/CancelNewChatBtn';
import ChatRequest from '../components/ChatRequest';
import { auth } from '../services/firebase';
import { db } from '../services/firebase';

export default class ChatList extends Component {
	constructor(props) {
		super(props)
		this.state = {
			user: auth().currentUser,
            chats: [],
			readError: null,
			writeError: null,
            loadingChats: false,
            pendingChatRequest: false,
		};
        this.myRef = React.createRef();
	}

	componentDidMount() {
		this.setState({ readError: null, loadingChats: true });

		try {
            // Get all chats for current user
			db.ref('user-chats').child(this.state.user.uid).on('value', (snapshot) => {
                if (snapshot.exists() === false) {
                    this.setState({ loadingChats: false });
                    return
                }

                let chatIds = Object.keys(snapshot.val())

                for (let chatId of chatIds) {
                    // Get chat info
                    db.ref('chats').child(chatId).on('value', (snapshot) => {
                        var chat = snapshot.val();
                        var chats = {...this.state.chats}

                        chat.id = chatId

                        if (chat.isActive === true || chat.isActive === undefined) {
                            chats[chatId] = chat
                        } else {
                            delete chats[chatId]
                        }

                        this.setState({chats})
                    });
                }

                this.setState({ loadingChats: false });
            });


            // Check for pending chat requests
            db.ref('chat-requests').child("mentalhealth").child(this.state.user.uid).on('value', (snapshot) => {
                if (snapshot.exists() === false) {
                    return
                }

                var pending = false

                if (snapshot.val()["status"] === "pending") {
                    pending = true
                }

                this.setState({ pendingChatRequest: pending })
            });

        } catch (error) {
            this.setState({ readError: error.message, loadingChats: false });
        }
	}

    formatTime(timestamp) {
        const d = new Date(timestamp * 1000);
        const time = `${d.getHours()}:${d.getMinutes()} ${(d.getMonth()+1)}/${d.getDate()}`;
        return time
    }

    // Parses the chat partner and returns ChatRow
    chatRow(chat) {
        var partnerId = ""
        let memberIds = Object.keys(chat.members)

        for (var memberId of memberIds) {
            if (memberId !== this.state.user.uid) {
                partnerId = memberId
            }
        }

        if (partnerId === null) {
            return
        }

        return (
            <div key={chat.sentDate} className='list-group-item'>
                <ChatRow
                    chatId = {chat.id}
                    userId = {partnerId}
                />
            </div>
        )
    }

    render() {
        let chats = []

        for (let chatId in this.state.chats) {
            let chat = this.state.chats[chatId]
            chats.push(chat)
        }

        var userName = `guest-${this.state.user.uid}`

        if (this.state.user.email) {
            userName = this.state.user.email
        }

        return (
            <div>
                <Header />

                <div className='container chat-area' ref={this.myRef}>
                    <div className='row'>
                        <div className='col-sm'>
                            <div>
                                <h4>Chat Sessions</h4>
                            </div>
                            {/* loading indicator */}
                            {this.state.loadingChats ? (
                                <div className='spinner-border text-success' role='status'>
                                    <span className='sr-only'>Loading</span>
                                </div>
                            ) : "" }
                            {/* pending chat request */}
                            {this.state.pendingChatRequest ? (
                                <div>
                                    <div>
                                        Pending Chat Request
                                    </div>
                                    <CancelNewChatBtn />
                                </div>
                            ) : <NewChatBtn /> }
                            {/* chat area */}
                            <div className='list-group'>
                                {chats.map(chat => {
                                    return this.chatRow(chat)
                                })}
                            </div>
                        </div>
                        <div className='col-sm'>
                            <ChatRequest />
                        </div>
                    </div>
                </div>

                <div className='py-5 mx-3'>
                    Loggged in as: <strong className='text-info'>{userName}</strong>
                </div>
            </div>
        );
    }
}
